import { makeSubStore } from '@jarvis.oddle/core/tools/redux/store'
import { STORE_KEY } from './constants'
import * as actions from './actions'
import { initialState, reducers } from './reducers'

export const initialiseState = async ({ req, store, parsedUrl }) => {
  const agreementsState = store.getState()[STORE_KEY]
  const metaState = store.getState()['@meta']
  const { detailMenuSite: { data: { menuId } } } = metaState
  const { path } = parsedUrl
  switch (path[0]) {
    case 'terms':
      if (!agreementsState.termsAndConditions.fetched) {
        await store.dispatch(actions.fetchTermsAndConditionsAction({ req, menuId }))
      }
      break
    case 'privacy':
      if (!agreementsState.privacyPolicy.fetched) {
        await store.dispatch(actions.fetchPrivacyPolicyAction({ req, menuId }))
      }
      break
    default:
      break
  }
}

export default makeSubStore(STORE_KEY, actions, reducers, initialState, initialiseState)
